module.exports = __webpack_public_path__ + "img/80nv.d82c84f1.png";